export default {
  Title: 'Jobs',
  Generate: 'Generate job posting',
  Regenerate: 'Regenerate',
  Edit: 'Edit',
  Empty: 'This client has no jobs yet. Generate a posting from the care plan and intake forms.',
  LoadError: 'The jobs could not be loaded.',
  SyncedFromCareerFe: 'Synced from Career-FE. Change this job in the legacy careers pages.',
  Created: 'Created',
  Rate: 'Rate',
  Start: 'Start',
  Schedule: 'Schedule',
  CareNeeds: 'Care needs',
  Languages: 'Languages',
  Considerations: 'Household considerations',
  NoSchedule: 'No schedule',
  NiceToHave: 'nice to have',
  PerHour: '/hr',
  NotesTitle: 'Notes from the draft',
  Status: {
    REVIEW: 'Review',
    ACTIVE: 'Active',
    DEACTIVATED: 'Deactivated',
  },
  StartWindows: {
    IMMEDIATELY: 'Immediately',
    ONEWEEK: 'Within 1 week',
    TWOWEEK: 'Within 2 weeks',
    ONEMONTH: 'Within 1 month',
    TWOMONTH: 'Within 2 months',
    FLEXIBLE: 'Flexible',
  },
  Days: {
    MONDAY: 'Mon',
    TUESDAY: 'Tue',
    WEDNESDAY: 'Wed',
    THURSDAY: 'Thu',
    FRIDAY: 'Fri',
    SATURDAY: 'Sat',
    SUNDAY: 'Sun',
  },
  GenerateDialog: {
    GenerateTitle: 'Generate a job posting',
    RegenerateTitle: 'Regenerate the job posting',
    Overwrite: 'This replaces the posting text, schedule, care needs and languages, and removes any hand edits. The status stays.',
    Client: 'Client',
    Generated: 'Job posting generated for #{clientName}. It is in Review.',
    Guidance: 'Guidance (optional)',
    Working: 'Drafting the posting. Keep this dialog open.',
    Generate: 'Generate',
  },
  EditDialog: {
    Title: 'Edit the job posting',
    Summary: 'Summary',
    Description: 'Posting text',
    HourlyRate: 'Hourly rate ($)',
    StartWindow: 'Start',
    TimezoneNote: 'Times are in Toronto time.',
    Day: 'Day',
    StartTime: 'Start time',
    EndTime: 'End time',
    AddSlot: 'Add time slot',
    RemoveSlot: 'Remove time slot',
    Language: 'Language',
    Level: 'Level',
    Levels: {
      REQUIRED: 'Required',
      NICE_TO_HAVE: 'Nice to have',
    },
    AddLanguage: 'Add language',
    RemoveLanguage: 'Remove language',
  },
  Errors: {
    CLT_001: 'This client is not in Loom.',
    JOB_001: 'This job was not found. Reload the tab.',
    JOB_003: 'Check the fields and try again.',
    JOB_006: 'The client has no care plan with care details. Fill in the care plan first.',
    JOB_007: 'The client has no home address. Add one first.',
    JOB_008: 'The schedule form and the care plan give no days or times. Add a schedule first.',
    JOB_009: 'The posting could not be drafted. Try again.',
    JOB_010: 'Client-FE could not be read. Try again.',
    Default: 'Something went wrong. Try again.',
  },
};
